@if (loaded$ | async) {
  <div [@artistLoaded]="selectedArtist$ | async">
    <!-- スマートフォン向け -->
    @if (media.isActive('lt-md')) {
      <router-outlet></router-outlet>
    }
    <!-- デスクトップ向け -->
    @if (!media.isActive('lt-md')) {
      <app-artist-combined></app-artist-combined>
    }
  </div>
  @if (media.isActive('lt-md')) {
    <app-artist-footer
      [page]="artistPage$ | async"
    ></app-artist-footer>
  }
} @else {
  <app-progress-indicator></app-progress-indicator>
}

